import { render, staticRenderFns } from "./PatientFollowUpEdit.vue?vue&type=template&id=2323f616&scoped=true&"
import script from "./PatientFollowUpEdit.vue?vue&type=script&lang=js&"
export * from "./PatientFollowUpEdit.vue?vue&type=script&lang=js&"
import style0 from "./PatientFollowUpEdit.vue?vue&type=style&index=0&id=2323f616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323f616",
  null
  
)

export default component.exports